// extracted by mini-css-extract-plugin
export default {"wrapper":"m1-z","play":"n1-z"};